module.exports = "/_next/static/images/5fa03c342b318888726cc1a438658bd1-mgm-invite-ticket-5.jpg";